"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TargetsGeoTargetsToJSON = exports.TargetsGeoTargetsFromJSONTyped = exports.TargetsGeoTargetsFromJSON = exports.instanceOfTargetsGeoTargets = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the TargetsGeoTargets interface.
 */
function instanceOfTargetsGeoTargets(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfTargetsGeoTargets = instanceOfTargetsGeoTargets;
function TargetsGeoTargetsFromJSON(json) {
    return TargetsGeoTargetsFromJSONTyped(json, false);
}
exports.TargetsGeoTargetsFromJSON = TargetsGeoTargetsFromJSON;
function TargetsGeoTargetsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': !(0, runtime_1.exists)(json, 'country_code') ? undefined : json['country_code'],
        'cityIds': !(0, runtime_1.exists)(json, 'city_ids') ? undefined : json['city_ids'],
        'dmaIds': !(0, runtime_1.exists)(json, 'dma_ids') ? undefined : json['dma_ids'],
        'postalCodeIds': !(0, runtime_1.exists)(json, 'postal_code_ids') ? undefined : json['postal_code_ids'],
        'regionIds': !(0, runtime_1.exists)(json, 'region_ids') ? undefined : json['region_ids'],
    };
}
exports.TargetsGeoTargetsFromJSONTyped = TargetsGeoTargetsFromJSONTyped;
function TargetsGeoTargetsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'country_code': value.countryCode,
        'city_ids': value.cityIds === undefined ? undefined : Array.from(value.cityIds),
        'dma_ids': value.dmaIds === undefined ? undefined : Array.from(value.dmaIds),
        'postal_code_ids': value.postalCodeIds === undefined ? undefined : Array.from(value.postalCodeIds),
        'region_ids': value.regionIds === undefined ? undefined : Array.from(value.regionIds),
    };
}
exports.TargetsGeoTargetsToJSON = TargetsGeoTargetsToJSON;
